import { render, staticRenderFns } from "./OrderHoldDeliveryIframe.vue?vue&type=template&id=f42b94de&"
import script from "./OrderHoldDeliveryIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderHoldDeliveryIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports